import { FC } from 'react';
import {
  IBlockBase,
  IDidacticClassification,
} from '../../../endpoints/coachSessions';
import { ISportTaxonomy } from '../../../models/trainingStatistics';
import { BlockBase } from './BlockBase';
import BlockClassification from '../../../components/ProgrammingPage/BlockClassification/BlockClassification';
import { ExerciseCombo } from './ExerciseCombo';
import { ComposableFields } from './ComposableFields';
import styles from './BlockBase.module.scss';

interface SequentialBlockProps {
  block: IBlockBase;
  index: number;
  onChange: (patch: Partial<IBlockBase>) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  sport?: string | null;
  taxonomy?: ISportTaxonomy | null;
  totalBlocks?: number;
}

/**
 * Tipo 1 — Sequenziale.
 * Tutti i giocatori insieme fanno la stessa cosa.
 * Spec §4.1.
 */
export const SequentialBlock: FC<SequentialBlockProps> = ({
  block,
  index,
  onChange,
  onDelete,
  onDuplicate,
  onMoveUp,
  onMoveDown,
  sport,
  taxonomy,
  totalBlocks,
}) => {
  return (
    <BlockBase
      index={index}
      blockType="sequential"
      title={block.exerciseName ?? (block as any).customExerciseName ?? ''}
      durationMinutes={block.durationMinutes}
      transitionAfterMinutes={block.transitionAfterMinutes}
      onTransitionChange={(v) => onChange({ transitionAfterMinutes: v })}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
    >
      <div className={styles.fieldGrid}>
        {/* Nome esercitazione — testo libero o library (principio 1) */}
        <div className={`${styles.field} ${styles.fieldFull}`}>
          <label className={styles.fieldLabel}>Nome esercitazione</label>
          <ExerciseCombo
            value={block.exerciseName ?? (block as any).customExerciseName ?? ''}
            onChange={(name) => onChange({ exerciseName: name, ...({ customExerciseName: name } as any) })}
            placeholder="Cerca dalla library oppure scrivi a mano…"
          />
        </div>
      </div>

      {/* Parametri componibili a chip (principio 2): solo i campi usati,
          "+ campo" per attivarne altri, densità m²/giocatore automatica. */}
      <ComposableFields
        block={block}
        blockType="sequential"
        playerCount={block.involvedAthleteIds?.length}
        onChange={onChange}
      />

      {sport && taxonomy && (
        <BlockClassification
          value={block.didacticClassification ?? {}}
          onChange={(c: IDidacticClassification) =>
            onChange({ didacticClassification: c })
          }
          taxonomy={taxonomy}
          sport={sport}
          blockData={{
            exerciseName: block.exerciseName,
            notes: block.notes,
            order: block.order,
            durationMinutes: block.durationMinutes,
          }}
          totalBlocks={totalBlocks}
        />
      )}
    </BlockBase>
  );
};
